module.exports = __webpack_public_path__ + "img/ico-file-green.165f92e9.svg";